<template>
  <section v-if="otherStories.length" class="more-stories">
    <div class="container">
      <h2 class="more-stories__title">More stories</h2>
      <div class="more-stories__cards">
        <ComparisonCard
          v-for="story in otherStories"
          :key="story.slug"
          :title="story.title"
          :text="story.excerpt"
          :to="{ name: 'success-story', params: { slug: story.slug } }"
          :aria-label="`Read story: ${story.title}`"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ComparisonCard from '@/components/comparison/ComparisonCard.vue';
import { successStories } from '@/data/successStories';

export default {
  components: {
    ComparisonCard,
  },
  props: {
    currentSlug: {
      type: String,
      required: true,
    },
  },
  computed: {
    otherStories() {
      return successStories.filter((story) => story.slug !== this.currentSlug);
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1224px;
  margin: 0 auto;
}

.more-stories {
  background: #f5f8fa;
  padding: 80px 20px 100px;
}

.more-stories__title {
  font-weight: 600;
  font-size: 48px;
  line-height: 62px;
  letter-spacing: -0.02em;
  color: #17191d;
  text-align: center;
  margin-bottom: 48px;
}

.more-stories__cards {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
}

@media screen and (max-width: 768px) {
  .more-stories {
    padding: 50px 16px 60px;
  }

  .more-stories__title {
    font-size: 36px;
    line-height: 44px;
    margin-bottom: 32px;
  }

  .more-stories__cards {
    flex-direction: column;
    flex-wrap: nowrap;
  }
}
</style>
